import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createAppTheme } from './muiTheme';
import './darkmode.css';

const ThemeContext = createContext({
    themeMode: 'light',
    toggleThemeMode: () => {},
});

export const useThemeMode = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {
    const [themeMode, setThemeMode] = useState(() => {
        const saved = localStorage.getItem('themeMode');
        return saved === 'dark' ? 'dark' : 'light';
    });

    useEffect(() => {
        localStorage.setItem('themeMode', themeMode);
        const root = document.documentElement;
        // Setting data-theme triggers CSS custom properties defined in global.css
        root.setAttribute('data-theme', themeMode === 'dark' ? 'dark' : 'light');
    }, [themeMode]);

    const toggleThemeMode = () => {
        setThemeMode((prev) => (prev === 'light' ? 'dark' : 'light'));
    };

    const theme = useMemo(() => createAppTheme(themeMode), [themeMode]);

    const contextValue = useMemo(() => ({ themeMode, toggleThemeMode }), [themeMode]);

    return (
        <ThemeContext.Provider value={contextValue}>
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};

export default ThemeContext;
